import { useContext, useEffect, useState } from "react";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { ConvertToFloat } from "../../../Layout/Common/common";
import { ToolbarContainer } from "../toolbarContainer";
import { GlobalContext } from "../../../Context/GlobalContext";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { FamilyProductFeature, FamilyProductFeatureDetails } from "./familyProductFeature";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { ProductStockStatusContainer } from "../../../Layout/Common/productStockStatusContainer";
import { handleStockStatus } from "../../../utils/stockStatus";
import { useAuth } from "../../../Context/AuthContext";
import { isPlainLeftClick, useProductOverlay } from "../productOverlay/productOverlayContext";
import { useDevice } from "../../../Context/hook/useDeviceType";
import { ProductLink } from "../../../Layout/Common/productLink";

export const FamilyProductList = ({ row, feature }) => {
  const [product, setProduct] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [productStock, setProductStock] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { isBrowseOnly } = useAuth();
  const { getStockStatus } = useGlobalFunction();
  const overlay = useProductOverlay();
  const isMobile = useDevice()?.device === "mobile";
  const openInOverlay = (event) => {
    if (!overlay?.openProduct || !isPlainLeftClick(event)) return;
    event.preventDefault();
    overlay.openProduct(product.sku ?? product.productCode);
  };
  useEffect(() => {
    if (row) {
      setProduct(row);
      //fetchStockStatus(row.productId);
      if (row.stockStatus) {
        const status = handleStockStatus(row.stockStatus);
        setProductStock(status);
      }
    }
  }, [row]);

  const fetchStockStatus = async (productId) => {
    let res = await getStockStatus(productId ?? 0);
    if (res) setProductStock(res);
  };

  useEffect(() => {
    if (
      globalcontext.CartItem &&
      globalcontext.CartItem.cartItem &&
      globalcontext.CartItem.cartItem.length > 0 &&
      row
    ) {
      var products = globalcontext.CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(row.productId));
      setCartItem({
        prod_id: row.productId,
        qty: filterProductId && filterProductId.qty ? filterProductId.qty : 0,
      });
    } else {
      setCartItem({
        prod_id: row.productId,
        qty: 0,
      });
    }
  }, [globalcontext.CartItem, row]);

  const canBuy = productStock && productStock.isShowBuy == true && !isBrowseOnly;
  const quantityParams = product
    ? { code: product.productCode, desc: product.description, img: product.prodImage }
    : null;
  const renderAvailability = () => (
    <span className="proAvailablity">
      Availability:
      {productStock ? (
        <ProductStockStatusContainer params={productStock} stockStatus={product.stockStatus.stockStatusRaw} />
      ) : (
        <span
          className="cc-pro-available pl-1"
          dangerouslySetInnerHTML={{
            __html: product.stockStatus.stockStatusRaw,
          }}
        ></span>
      )}
    </span>
  );

  if (isMobile) {
    return (
      <div className="search-row rowProducts-list position-relative">
        {product && (
          <div className="row" data-id={product.productId}>
            <div className="col-md-12 col-lg-7">
              <div className="row">
                <div className="col-md-9 col-lg-9">
                  <h6 className="product-title">
                    <ProductLink to={product.link} onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
                      {product.description}
                    </ProductLink>
                    {product.isNew && <small className="product-stage new-product">New</small>}
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-5 text-end row-productListing">
              <div className="rowListing-productInfo mt-3 mt-lg-0">
                <div className="rowProduct-imageLft d-block d-md-none">
                  <ProductLink to={product.link} onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
                    <ImageWithDefault src={product.prodImage} className="img-fluid" alt="product image" />
                  </ProductLink>
                </div>
                <div className="rowProduct-contentRft">
                  <div className="row-price">
                    <p>
                      $ {ConvertToFloat(product.price)} <span>ex GST</span>
                    </p>
                  </div>
                  <div className="d-none d-sm-flex flex-wrap gap-2 product-code-availability">
                    <span className="d-block d-sm-inline-block">Code: {product.productCode}</span>
                    {renderAvailability()}
                  </div>
                  <div className="row-products-info">
                    <div className="product-adding-icons pt-0 rowProducts-addingIcons">
                      <ToolbarContainer product={product} cartItem={cartItem} showPriceTable={true} />
                    </div>
                    {canBuy && <QuantityStripper wrapperClass="flex-nowrap" prd={cartItem} params={quantityParams} />}
                  </div>
                </div>
              </div>
              <div className="row-product-features product-features d-block d-md-none">
                <div className="d-sm-none product-code-availability">
                  <span className="d-block">Code: {product.productCode}</span>
                  {renderAvailability()}
                </div>
                <FamilyProductFeatureDetails items={feature} />
                <ProductLink
                  to={product.link}
                  className="fs-14 text-link text-decoration-underline d-block"
                  onClick={openInOverlay}
                  data-overlay-skip={overlay?.openProduct ? "" : undefined}
                >
                  More Info
                </ProductLink>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="search-row rowProducts-list position-relative">
      {product && (
        <div className="row" data-id={product.productId}>
          <div className="col-md-12 col-lg-7">
            <div className="row">
              <div className="col-md-3 col-lg-3 row-pro-img ">
                <ProductLink to={product.link} className="family-img-thumbnail" onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
                  <ImageWithDefault
                    src={product.prodImage}
                    className="img-fluid"
                    alt="product image"
                    style={{ maxWidth: "138px", maxHeight: "138px" }}
                  />
                </ProductLink>
              </div>
              <div className="col-md-9 col-lg-9">
                <h6 className="product-title">
                  <ProductLink to={product.link} onClick={openInOverlay} data-overlay-skip={overlay?.openProduct ? "" : undefined}>
                    {product.description}
                  </ProductLink>
                </h6>
                {feature && <FamilyProductFeature params={feature} />}
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-5 text-end row-productListing">
            <div className="row-price">
              <p>$ {ConvertToFloat(product.price)} </p>
            </div>
            <div className="product-code-availability d-flex flex-wrap gap-2 justify-content-end">
              <span>Code: {product.productCode}</span>
              {renderAvailability()}
            </div>
            <div className="row-products-info">
              <div className="product-adding-icons rowProducts-addingIcons">
                <ToolbarContainer product={product} cartItem={cartItem} showPriceTable={true} />
              </div>
              {canBuy && (
                <div className="rowProduct-qty rowProduct-btns" style={{ display: "block" }}>
                  <QuantityStripper prd={cartItem} params={quantityParams} />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
